import {createContext, useContext, useState} from "react";
import config from "../config.json";
import {message} from "antd";


const AppContext = createContext(null);


function AppProvider({children}) {
    const [lang, setLang] = useState("en");
    const [isLoading, setIsLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const apiUrl = config.API;
    const appVersion = config.VERSION;

    const success = (message) => {
        messageApi.open({
            type: 'success',
            content: message,
        });
    };
    const error = (message) => {
        messageApi.open({
            type: 'error',
            content: message,
        });
    };

    return (
        <>
            {contextHolder}
            <AppContext.Provider value={{
                isLoading, setIsLoading, lang, setLang, apiUrl, error, success, appVersion,
            }}>
                {children}
            </AppContext.Provider>
        </>
    )
}

function useApp() {
    const context = useContext(AppContext);
    if (context === undefined) {
        throw new Error('AuthContext was used outside AppProvider');
    }
    return context;
}

export {AppProvider, useApp};